/**
 * This reducer is used for fetching shipping methods
 */

import { persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage'; // defaults to localStorage for web
import { CLEAR_TRANSFER_RECIPIENTS, GET_TRANSFER_RECIPIENT_METHODS, GET_TRANSFER_RECIPIENT_METHODS_FAILURE, GET_TRANSFER_RECIPIENT_METHODS_SUCCESS } from '../action/types';

const initialState = {
    transferRecipient :[],
    loading: false,
    statusCode: 0,
    statusMessage: '',
};

const usageTransferRecipientReducer = (state = initialState, action) => {
    switch (action.type) {
        case GET_TRANSFER_RECIPIENT_METHODS:
            return {
                ...state,
                loading: true,
            };
        case GET_TRANSFER_RECIPIENT_METHODS_SUCCESS:
            return {
                ...state,
                // shippingMethods: [...state.shippingMethods, ...action.payload],
                transferRecipient: [...action.payload.data],
                statusCode: action.statusCode,
                statusMessage: action.statusMessage,
                loading: false,
            };
        case GET_TRANSFER_RECIPIENT_METHODS_FAILURE:
            return {
                ...state,
                transferRecipient: [],
                statusCode: action.statusCode,
                statusMessage: action.statusMessage,
                loading: false,
            };
        case CLEAR_TRANSFER_RECIPIENTS:
            return {
                ...state,
                transferRecipient: [],
            };
        default: {
            return { ...state };
        }
    }
};

export default persistReducer(
    {
        key: 'usageTransferRecipientKey',
        storage: storage,
    },
    usageTransferRecipientReducer
);
